import { authClient, API } from '../../utils/index'

/**
 * Los textos legales del sitio.
 *
 * SOLO SE LEEN Y SE GUARDAN. No hay crear ni borrar, y no falta nada: son
 * cuatro documentos por tres idiomas, declarados en el backend. El pie de
 * sailradar.com enlaza a sus direcciones, así que uno de menos es un enlace
 * roto a la política que el sitio dice tener.
 *
 * La identidad de un documento es la pareja clave+idioma, no un id: por eso
 * las rutas son `/legal/privacidad/es` y no `/legal/<id>`.
 */

export const getLegales = () => {
	return authClient().get(`${API}/legal`)
}

export const getLegal = (clave, idioma) => {
	return authClient().get(`${API}/legal/${clave}/${idioma}`)
}

/**
 * Guarda el texto.
 *
 * El HTML lo sanea EL SERVIDOR. El editor solo ofrece lo que está admitido,
 * pero eso es una ayuda para escribir, no una barrera: lo que decide qué se
 * publica es `utils/legal.js` del backend.
 */
export const updateLegal = (clave, idioma, datos) => {
	return authClient().put(`${API}/legal/${clave}/${idioma}`, datos)
}
